import { PrivateKeys } from "./PrivateKeys";
import { generateState } from "./generateState";
import { generateCodeVerifier } from "./generateCodeVerifier";
import { generateChallenge } from "./generateChallenge";
import { generateNonce } from "./generateNonce";









export function generateProofKey(connection: string, redirectUrl: string): PrivateKeys {
    const codeVerifier = generateCodeVerifier();
    const codeChallenge = generateChallenge(codeVerifier);
    const state = generateState(connection, redirectUrl);
    const nonce = generateNonce();

    return {
        codeVerifier,
        codeChallenge,
        nonce,
        state
    };
}
